import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {CssBaseline, GlobalStyles} from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles
        styles={{
          // Apply to scrollable elements only
          '[data-scrollable="true"]': {
            overflowY: "auto",
            scrollbarGutter: "stable", // Ensures consistent space for scrollbars
            "&::-webkit-scrollbar": {
              background: "transparent",
              width: "8px", // Size of the scrollbar
            },
            "&::-webkit-scrollbar-thumb": {
              background: "transparent", // Hidden by default
              borderRadius: "4px",
            },
            "&:hover::-webkit-scrollbar-thumb": {
              background: "rgba(0, 0, 0, 0.1)", // Visible on hover
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent", // Optional track color
            },
            boxSizing: "border-box",
          },
        }}
        />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
